import { render, staticRenderFns } from "./AdminBorrowableTags.vue?vue&type=template&id=0a951d40"
import script from "./AdminBorrowableTags.vue?vue&type=script&lang=js"
export * from "./AdminBorrowableTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports